import { render } from "./LiveStats.vue?vue&type=template&id=2e29828b&scoped=true"
import script from "./LiveStats.vue?vue&type=script&lang=js"
export * from "./LiveStats.vue?vue&type=script&lang=js"

import "./LiveStats.vue?vue&type=style&index=0&id=2e29828b&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e29828b"]])

export default __exports__